import { render, staticRenderFns } from "./ConfigurarPlazosAcreditacion.vue?vue&type=template&id=71def387&"
import script from "./ConfigurarPlazosAcreditacion.vue?vue&type=script&lang=js&"
export * from "./ConfigurarPlazosAcreditacion.vue?vue&type=script&lang=js&"
import style0 from "./ConfigurarPlazosAcreditacion.vue?vue&type=style&index=0&id=71def387&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports